document.addEventListener('click', function (event) {
  const btn = event.target.closest('.size_guide_content [data-unit]');
  if (!btn) return;

  const container = btn.closest('.size_guide_content');
  if (!container) return;

  const unit = btn.getAttribute('data-unit');
  const buttons = container.querySelectorAll('[data-unit]');
  const tables = container.querySelectorAll('.size-chart-table[data-table]');

  buttons.forEach((b) => {
    const isActive = b.getAttribute('data-unit') === unit;
    b.classList.toggle('is-active', isActive);
  });

  tables.forEach((table) => {
    const show = table.getAttribute('data-table') === unit;
    table.hidden = !show;
    table.classList.toggle('is-hidden', !show);
  });
});

document.addEventListener('click', function (event) {
  const btn = event.target.closest('.size_guide_content [data-size-system]');
  if (!btn) return;

  const container = btn.closest('.size_guide_content');
  if (!container) return;

  const system = btn.getAttribute('data-size-system');

  container.querySelectorAll('[data-size-system]').forEach((b) => {
    b.classList.toggle('is-active', b.getAttribute('data-size-system') === system);
  });

  container.querySelectorAll('.size-cell').forEach((cell) => {
    const val = cell.getAttribute('data-size-' + system);
    cell.textContent = val != null ? val : cell.getAttribute('data-size-int');
  });
});